import { Pages } from 'constants/menu'
import type { SubPage } from 'components/left-submenu/LeftSubmenu'

interface ContractInformationSubPageOptions {
  locked?: boolean
}

export function getContractInformationSubPages({
  locked = false,
}: ContractInformationSubPageOptions = {}): SubPage[] {
  const subPages: SubPage[] = [
    {
      title: 'Sale Information',
      link: Pages.SALE_INFORMATION,
      locked,
    },
    {
      title: 'Conditions',
      link: Pages.CONDITIONS,
      locked,
    },
    {
      title: 'Special Conditions',
      link: Pages.SPECIAL_CONDITIONS,
      locked,
    },
    {
      title: 'Settlement',
      link: Pages.SETTLEMENT,
      locked,
    },
    {
      title: 'Deposits',
      link: Pages.DEPOSITS,
      locked,
    },
  ]

  return subPages
}
